import urljoin from 'url-join';
import { portalApi } from './index.api';

const DISCOVERY = "smartPanels";
const PROJECTS = "projects";
/** Admin pipeline status reads under PortalApi admin routes. */
const PIPELINE_STATUS = urljoin('admin', 'pipeline-status');

export const projectsApi = portalApi.injectEndpoints({
	endpoints: (builder) => ({
		projects: builder.query({
			query: () => ({
				// baseQueryWithAuth handles authorization header automatically
				url: PROJECTS,
				method: 'GET',
			}),
			providesTags: ['projects']
		}),
		projectId: builder.query({
			query: (projectId) => ({
				// baseQueryWithAuth handles authorization header automatically
				url: urljoin(PROJECTS, projectId),
				method: 'GET',
			})
		}),
		projectCode: builder.query({
			query: (projectCode) => ({
				// baseQueryWithAuth handles authorization header automatically
				url: urljoin(PROJECTS, "projectCode", projectCode),
				method: 'GET',
			})
		}),
		projectRecognizeRevenue: builder.query({
			query: (projectId) => ({
				// baseQueryWithAuth handles authorization header automatically
				url: urljoin(PROJECTS, "recognize-revenue", projectId),
				method: 'POST',
				body: { projectId }
			})
		}),

		empty: builder.query({
			query: (projectId) => {
				if (!projectId) {
					throw new Error('projectId is required');
				}
				return {
					// baseQueryWithAuth handles authorization header automatically
					url: urljoin(PROJECTS, "empty", projectId),
					method: 'GET',
				};
			}
		}),

		/**
		 * Latest pipeline stage summary per (pipeline, stage). Not used by project PipelineStatus panel
		 * (`usePipelineStatus` uses `pipelineStatusFacts`); kept for compatibility / other callers.
		 */
		pipelineStatus: builder.query({
			query: (projectId) => {
				if (!projectId) {
					throw new Error('projectId is required');
				}
				return {
					url: urljoin(PIPELINE_STATUS, "projects", projectId),
					method: 'GET',
				};
			},
			providesTags: (result, error, projectId) => [{ type: 'pipelineStatus', id: projectId }],
		}),

		/** Append-only PipelineStatus facts (rich rows). GET /api/v1/admin/pipeline-status/projects/{projectId}/facts */
		pipelineStatusFacts: builder.query({
			query: (projectId) => {
				if (!projectId) {
					throw new Error('projectId is required');
				}
				return {
					url: urljoin(PIPELINE_STATUS, "projects", projectId, "facts"),
					method: 'GET',
				};
			},
			providesTags: (result, error, projectId) => [{ type: 'pipelineStatusFacts', id: projectId }],
		}),
	})
});
/* 
√ GET /api/v1/projects
√ GET /api/v1/projects/{projectId}
√ GET /api/v1/projects/projectCode/{projectCode}
√ GET /api/v1/projects/empty/{projectId}
√ POST /api/v1/projects/recognize-revenue/{projectId}
√ GET /api/v1/admin/pipeline-status/projects/{projectId}  (pipelineStatus query)
√ GET /api/v1/admin/pipeline-status/projects/{projectId}/facts  (pipelineStatusFacts query)
 */
export const {
	useProjectsQuery,
	useEmptyQuery,
	useProjectCodeQuery,
	useProjectIdQuery,
	useProjectRecognizeRevenueQuery,
	usePipelineStatusQuery,
	usePipelineStatusFactsQuery,
} = projectsApi;
